import axios from 'axios';

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.getElementById('csrf-token').content;

export default class Api {
}

Api.saveNaumenData = function (domain, accessKey) {
  return axios.post('/install/naumen', {
    domain,
    accessKey,
    auth: window.BX24.getAuth(),
  });
};

Api.getSettings = function () {
  return axios.post('/api/settings/index', {
    auth: window.BX24.getAuth(),
  });
};

Api.saveSettings = function (data) {
  return axios.post('/api/settings/save', {
    data,
    auth: window.BX24.getAuth(),
  });
};

Api.getFormData = function () {
  return axios.post('/api/proxy/form', {
    auth: window.BX24.getAuth(),
  });
};

Api.startServiceCallProcessing = function (elementID) {
  return axios.post('/api/queue/request', {
    element_id: elementID,
    auth: window.BX24.getAuth(),
  });
};

Api.startCommentProcessing = function (elementID) {
  return axios.post('/api/queue/comment', {
    element_id: elementID,
    auth: window.BX24.getAuth(),
  });
};

Api.getUserServiceCalls = function () {
  return axios.post('/api/proxy/servicecall', {
    auth: window.BX24.getAuth(),
  });
};

Api.getServiceCall = function (serviceCallUUID) {
  return axios.post(`/api/proxy/servicecall/${serviceCallUUID}`, {
    auth: window.BX24.getAuth(),
  });
};
